
import { NomenclatureCustomNameCreate, NomenclatureCustomNameItem } from "../../types"
import { ApiNomenclatureCustomName } from "services";
import { 
    fetchNomenclatureCustomNameCreate,
    fetchNomenclatureCustomNameDelete,
    fetchNomenclatureCustomNameDetail,
    fetchNomenclatureCustomNameEdit
} from "../../actions";
import { makeRequestWithSpinner } from "worker";
import { ActionPromise } from "bus/rootActions";
import { PayloadRequest } from "types/requestTypes";

export function* fetchNomenclatureCustomNameDetailWorker (action: ActionPromise<NomenclatureCustomNameItem, PayloadRequest>): Generator {
    try {
        const options = {
            fetcher: ApiNomenclatureCustomName.getNomenclatureCustomNameDetail,
            startFetching: fetchNomenclatureCustomNameDetail.start,
            stopFetching: fetchNomenclatureCustomNameDetail.stop,
            fill: fetchNomenclatureCustomNameDetail.fill,
            setErrorAction: fetchNomenclatureCustomNameDetail.error,
            fetcherParam: action.payload
        }

        const result = yield makeRequestWithSpinner<NomenclatureCustomNameItem, PayloadRequest>(options);
        yield action.resolve(result as NomenclatureCustomNameItem);
    } catch(e) {
        
    }
}


export function* fetchNomenclatureCustomNameCreateWorker (action: ActionPromise<void, NomenclatureCustomNameCreate>): Generator {
    try {
        const options = {
            fetcher: ApiNomenclatureCustomName.getNomenclatureCustomNameCreate,
            startFetching: fetchNomenclatureCustomNameCreate.start,
            stopFetching: fetchNomenclatureCustomNameCreate.stop,
            fill: fetchNomenclatureCustomNameCreate.fill,
            setErrorAction: fetchNomenclatureCustomNameCreate.error,
            fetcherParam: action.payload
        }

        yield makeRequestWithSpinner<void, NomenclatureCustomNameCreate>(options);
        yield action.resolve();
    } catch(e) {
        
    }
}



export function* fetchNomenclatureCustomNameEditWorker (action: ActionPromise<void, NomenclatureCustomNameItem>): Generator {
    try {
        const options = {
            fetcher: ApiNomenclatureCustomName.getNomenclatureCustomNameEdit,
            startFetching: fetchNomenclatureCustomNameEdit.start,
            stopFetching: fetchNomenclatureCustomNameEdit.stop,
            fill: fetchNomenclatureCustomNameEdit.fill,
            setErrorAction: fetchNomenclatureCustomNameEdit.error,
            fetcherParam: action.payload
        }

        yield makeRequestWithSpinner<void, NomenclatureCustomNameItem>(options);
        yield action.resolve();
    } catch(e) {
        
    }
}


export function* fetchNomenclatureCustomNameDeleteWorker (action: ActionPromise<void, PayloadRequest>): Generator {
    try {
        const options = {
            fetcher: ApiNomenclatureCustomName.getNomenclatureCustomNameDelete,
            startFetching: fetchNomenclatureCustomNameDelete.start,
            stopFetching: fetchNomenclatureCustomNameDelete.stop,
            fill: fetchNomenclatureCustomNameDelete.fill,
            setErrorAction: fetchNomenclatureCustomNameDelete.error,
            fetcherParam: action.payload
        }

        yield makeRequestWithSpinner<void, PayloadRequest>(options);
        yield action.resolve();
    } catch(e) {
        
    }
}